import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=8dea50ea&lang=pug&"
import script from "./Remote.vue?vue&type=script&lang=ts&"
export * from "./Remote.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports